import React, { useEffect } from "react";
import Dropdown from "components/dropdown";
import { Link, useNavigate } from "react-router-dom";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useBetween } from "use-between";
import _user from "_user";

import avatar from "assets/img/avatars/avatar.png";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const { user, setUser } = useBetween(_user);
  const navigate = useNavigate()

  useEffect(() => {

  }, [user]);

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-2xl border border-white/40 bg-white/60 p-2 shadow-lg shadow-shadow-500/40 backdrop-blur-xl transition-all duration-300 dark:border-white/10 dark:bg-[#0b14374d] dark:shadow-none">
      <div className="ml-[6px] animate-fadeInUp">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[100px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 transition-shadow duration-300 dark:!bg-navy-800 dark:shadow-none md:w-[100px] md:flex-grow-0 md:gap-1 xl:w-[100px] xl:gap-2">
        <div
          className="cursor-pointer rounded-full p-2 text-gray-600 transition-all duration-200 hover:bg-gray-100 hover:text-brand-500 active:scale-90 dark:hover:bg-white/10"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 animate-scaleIn text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 animate-scaleIn text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full ring-2 ring-transparent transition-all duration-200 hover:ring-brand-400/60"
              src={user && user.photo ? user.photo : avatar}
              alt={(user || {}).nombre || 'Usuario'}
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] border border-gray-100 bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!border-white/10 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hola, {(user || {}).nombre}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <a
                  href=" "
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Mi cuenta
                </a>
                <button
                  onClick={() => {
                    localStorage.removeItem("token");
                    setUser({});
                    navigate("/auth/login");
                  }}
                  className="cursor-pointer mt-3 text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in"
                >
                  Cerrar sesión
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
